import Vue from 'vue';
import ContactAPI from '../../api/contacts';
import ConversationApi from '../../api/conversations';
import * as types from '../mutation-types';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getContactConversation: $state => (
    id,
    currentId,
    isLimitedAgent,
    isPermissionSeeAllTeamConversation
  ) => {
    const currentConversations = $state.records[Number(id)] || [];

    let conversationsFiltered = currentConversations || []
    if (isLimitedAgent) {
      conversationsFiltered = currentConversations.filter(
        conversation =>
          conversation?.last_non_activity_message?.conversation?.assignee_id ===
          currentId
      );
    }

    if (isPermissionSeeAllTeamConversation) {
      conversationsFiltered = currentConversations.filter(
        conversation =>
          conversation?.meta?.team?.is_member ||
          conversation?.last_non_activity_message?.conversation?.assignee_id ===
            currentId
      );
    }

    return conversationsFiltered;
  },
  getConversations($state) {
    return $state.records;
  },
};

export const actions = {
  create: async ({ commit }, params) => {
    commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
      isCreating: true,
    });
    const {
      inboxId,
      message,
      contactId,
      sourceId,
      mailSubject,
      assigneeId,
    } = params;
    try {
      const { data } = await ConversationApi.create({
        inbox_id: inboxId,
        contact_id: contactId,
        source_id: sourceId,
        started_by: 'Agent',
        additional_attributes: {
          mail_subject: mailSubject,
        },
        message,
        assignee_id: assigneeId,
      });
      commit(types.default.ADD_CONTACT_CONVERSATION, {
        id: contactId,
        data,
      });
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
        isCreating: false,
      });
    }
  },
  get: async ({ commit, state }, contactId) => {
    const id = Number(contactId);
    if (state.records[id]?.length) {
      return;
    }
    commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await ContactAPI.getConversations(contactId);
      commit(types.default.SET_CONTACT_CONVERSATIONS, {
        id: contactId,
        data: response.data.payload,
      });
      commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
        isFetching: false,
      });
    }
  },
  fetch: async ({ commit }, contactId) => {
    commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const response = await ContactAPI.getConversations(contactId);
      commit(types.default.SET_CONTACT_CONVERSATIONS, {
        id: contactId,
        data: response.data.payload,
      });
      commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG, {
        isFetching: false,
      });
    }
  },

  needTemplate: async (_commit, params) => {
    const { inboxId, contactId, accountId } = params;
    try {
      const { data } = await ConversationApi.needTemplate({
        inbox_id: inboxId,
        contact_id: contactId,
        account_id: accountId,
      });

      return data;
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.default.SET_CONTACT_CONVERSATIONS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_CONTACT_CONVERSATIONS]: ($state, { id, data }) => {
    Vue.set($state.records, id, data);
  },
  [types.default.ADD_CONTACT_CONVERSATION]: ($state, { id, data }) => {
    const conversations = $state.records[id] || [];

    const updatedConversations = [...conversations];
    const index = conversations.findIndex(
      conversation => conversation.id === data.id
    );

    if (index !== -1) {
      updatedConversations[index] = { ...conversations[index], ...data };
    } else {
      updatedConversations.push(data);
    }

    Vue.set($state.records, id, updatedConversations);
  },
  [types.default.DELETE_CONTACT_CONVERSATION]: ($state, id) => {
    Vue.delete($state.records, id);
  },
  [types.default.UPDATE_CONTACT_CONVERSATION_STATUS]: (
    $state,
    { conversationId, status, snoozedUntil }
  ) => {
    Object.keys($state.records).forEach(contactId => {
      const conversations = $state.records[contactId];
      if (!conversations?.length) return;

      const index = conversations.findIndex(
        conversation => conversation.id === conversationId
      );
      if (index === -1) return;

      Vue.set(conversations[index], 'status', status);
      if (snoozedUntil !== undefined) {
        Vue.set(conversations[index], 'snoozed_until', snoozedUntil);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
